import { render } from "./PlanosCommonForm.vue?vue&type=template&id=0adf91f8"
import script from "./PlanosCommonForm.vue?vue&type=script&lang=js"
export * from "./PlanosCommonForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__